import React, { useState } from "react";
import ReactAvatarEditor from "react-avatar-editor";
import { UploadProfileImage } from "../../../firebase/db/files/crud.tsx";
import { useAuth } from "../../../contexts/authContext/index.jsx";
import { editRecord } from "../../../firebase/db/users/crud.tsx";

const UploadImage = ({ onClose }) => {
	const { currentUser } = useAuth();
	const [image, setImage] = useState("");
	const [allowZoomOut, setAllowZoomOut] = useState(false);
	const [scale, setScale] = useState<string>("1");
	const [position, setPosition] = useState({ x: 0.5, y: 0.5 });
	const [rotate, setRotate] = useState(0);
	const [borderRadius, setBorderRadius] = useState(50);
	const [width, setWidth] = useState(175);
	const [height, setHeight] = useState(175);
	const [preview, setPreview] = useState(null);
	const [editor, setEditor] = useState(null);

	const handleNewImage = (e) => {
		setImage(e.target.files[0]);
	};

	const handleOnClose = () => {
		onClose();
	};

	const handleScale = (e) => {
		setScale(`${parseFloat(e.target.value)}`);
	};
	const handlePositionChange = (position) => {
		setPosition(position);
	};
	const setEditorRef = (editor) => setEditor(editor);

	const handleSubmit = async (e: any) => {
		console.log("uid: " + currentUser.uid);
		e.preventDefault();
		try {
			if (editor) {
				const img = editor.getImageScaledToCanvas();
				// Convert canvas to Blob
				img?.toBlob(async (blob) => {
					if (blob) {
						const profile = await UploadProfileImage(
							blob,
							"profile.png",
							currentUser.uid // Replace with actual user ID
						);
						editRecord(currentUser.uid, {
							profile_url: profile.downloadURL // Assuming this returns the download URL
						});
					}
					handleOnClose();
				}, "image/png");
			}
		} catch (error) {
			console.error("Error uploading image:", error);
		}
	};

	return (
		<div>
			<div className="text-center">
				<ReactAvatarEditor
					ref={setEditorRef}
					scale={parseFloat(scale)}
					width={width}
					height={height}
					position={position}
					onPositionChange={handlePositionChange}
					rotate={parseFloat(rotate)}
					borderRadius={width / (100 / borderRadius)}
					image={image}
					color={[255, 255, 255, 0.6]}
					className="editor-canvas ml-auto mr-auto mb-4"
				/>
			</div>
			<br />
			<label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="file_input">
				Upload Photo
			</label>
			<input
				name="upload-img-input"
				onChange={handleNewImage}
				className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
				id="file_input"
				type="file"
			/>
			<br />
			<h3>Zoom</h3>
			<input
				className="w-full h-2 bg-gray-400 rounded-lg appearance-none cursor-pointer"
				name="scale"
				type="range"
				onChange={handleScale}
				min={allowZoomOut ? "0.1" : "1"}
				max="2"
				step="0.01"
				defaultValue="1"
			/>
			<div className="text-right">
				<button
					className="mt-4 px-5 py-2.5 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
					onClick={handleSubmit}>
					SAVE
				</button>
			</div>
		</div>
	);
};
export default UploadImage;
